<template>
  <el-dialog :visible="show" title="全景素材" append-to-body @close="$emit('update:show', false)" width="700px" :close-on-click-modal="false">
    <div class="preview-lists-box" v-loading="loading">
      <div class="preview-lists-header">
        <div class="left v-row v-row-align-center">
          <div v-if="editing" class="v-mr-10">
            <el-checkbox v-model="checkAll" @change="changeCheckAll"><span class="v-font-12">全选</span></el-checkbox>
          </div>
          <el-button size="min" class="v-mr-10" @click="batchDeleteMedia" v-if="editing" :disabled="lists.filter((item) => item.active).length == 0">删除</el-button>
          <el-button size="min" class="v-mr-10" :type="editing ? 'success' : 'warning'" @click="editing = !editing">{{ editing ? '完成' : '编辑' }}</el-button>
          <el-button size="min" @click="chooseFile" type="primary" :loading="uploadLoading">新增素材</el-button>
        </div>
        <div class="right v-row v-row-align-center">
          <el-select size="small" v-model="status" placeholder="转码状态筛选" style="width: 140px" class="v-mr-5">
            <el-option :value="1" label="转码中"></el-option>
            <el-option :value="2" label="转码完成"></el-option>
          </el-select>
          <el-input size="small" v-model="keyword" placeholder="请输入文件名称" style="width: 140px"></el-input>
          <el-button size="mini" type="primary" class="v-ml-5" @click="getList(1)">搜索</el-button>
          <el-button size="mini" class="v-ml-5" @click="reset">重置</el-button>
        </div>
      </div>

      <!-- 资源列表 -->
      <div v-if="lists.length" class="preview-lists">
        <div v-for="(item, index) in lists" :key="item.id" class="preview-item" :class="{ active: item.active }">
          <div class="preview-box">
            <template v-if="item.key_preview">
              <img @click="toggleActive(item)" class="preview" :src="item.key_preview" />
              <i v-if="item.active" class="iconfont icon-right right"></i>
            </template>
          </div>

          <!-- 标题、分类、查看、修改、删除 -->
          <div class="preview-footer">
            <el-checkbox v-model="item.active" :disabled="editing"></el-checkbox>
            <div class="name v-ml-5" @click="toggleActive(item)">
              <div class="txt v-ellipsis">{{ item.name }}</div>
            </div>
            <div class="operate">
              <a class="operate-btn" :href="item.key_preview" target="_blank"><i class="el-icon-zoom-in"></i></a>
              <i @click="editName(item)" class="operate-btn el-icon-edit v-mr-10 v-ml-10"></i>
              <el-popconfirm title="确认删除?" @onConfirm="deleteMedia(item)">
                <i slot="reference" class="operate-btn el-icon-delete"></i>
              </el-popconfirm>
            </div>
          </div>

          <div v-if="item.uploading" class="uploading-mask">
            <div class="uploading-box">
              <div v-if="item.oversize">
                <el-link type="danger" style="font-size: 12px; line-height: 20px">文件体积过大,最大支持{{ maxSize / 1024 }}M</el-link>
                <div>
                  <i class="operate-btn el-icon-delete" @click="lists.splice(index, 1)"></i>
                </div>
              </div>
              <el-progress v-else style="width: 120px; margin: 0 auto" :text-inside="true" :stroke-width="24" :percentage="item.percent" status="success"></el-progress>
            </div>
          </div>

          <div v-if="item.status == 1" class="transcoding-mask">转码中..</div>
        </div>
      </div>

      <el-pagination
        v-if="lists.length > 0"
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
        :current-page.sync="page"
        :total="total"
      ></el-pagination>

      <div class="placeholder v-row v-row-center" v-if="lists.length == 0">
        <div>暂无资源数据</div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" size="small" :loading="uploadLoading" :disabled="editing">确 定</el-button>
    </div>
    <input type="file" hidden ref="fileInput" multiple accept="image/*" />
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    ids: {
      //过滤已选
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data() {
    return {
      editing: false,
      loading: false,
      uploadLoading: false,
      lists: [],
      page: 1,
      page_size: 10,
      total: 0,
      keyword: '',
      checkAll: false, //全选
      status: '',
      maxSize: 1024 * 100,
    };
  },

  watch: {
    editing: function () {
      this.checkAll = false;
      this.lists.forEach((item) => {
        item.active = false;
      });
      this.$forceUpdate();
    },
  },

  created() {
    this.getList();
  },

  methods: {
    //资源列表
    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.material.lists({
          page: this.page,
          page_size: this.page_size,
          status: this.status,
          keyword: this.keyword,
          select_ids: this.ids,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
        this.checkAll = false;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    reset() {
      this.status = '';
      this.keyword = '';
      this.getList(1);
    },

    //单条删除
    deleteMedia(row) {
      this.doDeleteMedia([row.id]);
    },

    //批量删除文件
    async batchDeleteMedia() {
      try {
        let ids = this.lists.filter((item) => item.active).map((item) => item.id);
        await this.$confirm('确认删除选中项?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.doDeleteMedia(ids);
      } catch (e) {
        console.error(e);
      }
    },

    //删除多媒体文件
    async doDeleteMedia(material_ids) {
      try {
        await this.api.material.delete({ material_ids });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //切换勾选
    toggleActive(row) {
      if (!row.id && row.status != 1) {
        return;
      }
      if (this.disable == 1 && row.status == 1) {
        this.$message.error('不能选择转码中的全景素材，请转码完成后再试');
        return;
      }
      if (!this.multiple && !row.active && !this.editing) {
        this.lists.forEach((item) => {
          item.active = false;
        });
      }
      row.active = !row.active;
      this.$forceUpdate();
    },

    //选择上传文件
    chooseFile() {
      let fileInput = this.$refs.fileInput;
      fileInput.click();
      fileInput.onchange = (e) => {
        let files = e.target.files;
        this.doUpload(files);
      };
    },

    //上传文件
    async doUpload(files) {
      this.uploadLoading = true;
      let mediaData = [];
      let uploadingFiles = Array.from(files).map((item) => {
        return {
          name: item.name,
          size: item.size,
          uploading: true,
          percent: 0,
          file: item,
          oversize: item.size / 1024 >= this.maxSize,
        };
      });
      this.lists = uploadingFiles.concat(this.lists);
      this.lists.forEach((item, index) => {
        if (item.oversize || !item.uploading) {
          return;
        }
        (async () => {
          let res = await this.utils.upload.uploadFile(item.file, {
            progress: (data) => {
              item.percent = parseInt(data.total.percent);
            },
          });
          mediaData.push({ key: res.key, name: res.name });
          res.key_preview = res.preview;
          this.$set(this.lists, index, res);
          if (mediaData.length == uploadingFiles.filter((item) => !item.oversize).length) {
            this.addToMedia(mediaData);
          }
        })();
      });
    },

    //加入媒体库
    async addToMedia(keys) {
      try {
        await this.api.material.addMaterial({ keys });
        this.getList(1);
      } catch (e) {
        console.error(e);
      }
      this.uploadLoading = false;
    },

    //全选
    changeCheckAll() {
      this.lists.forEach((item) => {
        this.$set(item, 'active', this.checkAll);
      });
    },

    //预览图片
    toPreview(url) {
      window.open(url, '_blank');
    },

    //修改资源名称
    async editName(row) {
      try {
        let res = await this.$prompt('修改素材名称', '重命名', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '1-20个字符',
          inputValue: row.name,
          inputPattern: /^[\S]{1,20}$/,
          inputErrorMessage: '长度不正确',
          closeOnClickModal: false,
        });
        this.loading = true;
        await this.api.material.update({
          field_data: { name: res.value },
          id: row.id,
        });
        this.$message.success('修改成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //确认选择
    doSubmit() {
      let selected = this.lists.filter((item) => item.active);
      if (selected.length == 0) {
        this.$message.error('请先选择素材');
        return;
      }
      this.$emit('select', selected);
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped lang="scss">
.preview-lists-box {
  min-height: 100px;
  padding: 0 10px;
  flex: 1;
}

.preview-lists-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.preview-lists {
  display: flex;
  flex-wrap: wrap;
  height: 350px;
  overflow-y: auto;
  align-items: flex-start;
  align-content: flex-start;
}

.preview-item {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  display: inline-block;
  width: 200px;

  &.active {
    background: #eee;
  }

  &.active:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    border-left: 40px solid transparent;
    border-top: 40px solid #409eff;
    z-index: 3;
  }

  &.active .right {
    color: #fff;
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 4;
    font-size: 12px;
  }

  .preview-box {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
  }

  .preview {
    display: block;
    cursor: pointer;
    max-width: 100%;
    max-height: 100%;
  }
}

.preview-footer {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px;
  min-height: 30px;
  box-sizing: border-box;

  .name {
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 10px;
    min-width: 0;
  }

  .category {
    margin-right: 3px;
    flex-shrink: 0;
    font-size: 12px;
    color: #409eff;
  }

  .txt {
    flex: 1;
    min-width: 0;
  }

  .operate {
    display: flex;
    align-items: center;
  }

  .operate-btn {
    color: #666;
  }
}

.placeholder {
  text-align: center;
  line-height: 100px;
}

.upload-btn-box {
  width: 200px;
}

.upload-btn {
  position: relative;
  width: 100%;
  height: 100px;
  line-height: 1;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 10px 0;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-txt {
  color: #999;
  font-size: 12px;
}

.uploading-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.5);
}

.uploading-box {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.transcoding-mask {
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
